const SORT_NEWEST_FIRST = "newest";
const SORT_OLDEST_FIRST = "oldest";

export { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST };
